export function ArtikelPriceAktivBadge() {
  return (
    <span className="ml-2 inline-flex items-center rounded-full bg-accent-soft px-2 py-0.5 text-[11px] font-semibold text-accent">
      Aktiv
    </span>
  );
}

export function ArtikelPricePassendBadge() {
  return (
    <span className="ml-2 text-xs font-medium text-label-tertiary">passend</span>
  );
}
